import React from 'react';
import { Link } from 'react-router-dom';

const TheCompetitionSection = () => {
  return (
    <section className="bg-rosewood text-white text-center px-6 py-12">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl font-bold mb-4">
          The Competition: You vs. Them
        </h3>
        <p className="text-lg leading-relaxed mb-6">
          Big-box retailers have the tools, data, and buying power to
          outmaneuver local stores. Most independent businesses are fighting
          uphill—alone.
        </p>
        <p className="text-lg font-semibold italic">
          It's time to change that.
        </p>
        <div className="mt-8">
          <Link
            to="/thecompetition"
            className="inline-block bg-white text-rosewood font-semibold px-6 py-3 rounded shadow hover:bg-cool-gray transition"
          >
            See the Playing Field →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TheCompetitionSection;
